import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchFilters} from "./filterApi";
import _ from 'lodash'
import moment from "moment";

export const defaultFiltersValue = {
    cleanerNumber: null,
    zones: [],
    orderNumber: null,
    status: 0,
    date: moment().format('YYYY-MM-DD')
};

const initialState = {
    filtersData: {
        cleaners: [],
        statuses: {},
        zones: [],
        orders: []
    },
    filtersValue: Object.assign({}, defaultFiltersValue)
};

export const loadFiltersAsync = createAsyncThunk(
    'filters/fetch',
    async (params = {}) => {
        const response = await fetchFilters(params);
        return response.data;
    }
);

export const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        modifyFilterValue(state, action) {
            if (action.payload.strategy) {
                const strategy = action.payload.strategy;
                const value = action.payload.value;
                let newState;
                if (strategy === 'without') {
                    newState = _.without(
                        state.filtersValue[action.payload.key],
                        ...(_.isArray(value) ? value : [value])
                    )
                } else if (strategy === 'union') {
                    newState = _.union(
                        state.filtersValue[action.payload.key],
                        value
                    )
                }
                state.filtersValue[action.payload.key] = newState;
            } else {
                state.filtersValue[action.payload.key] = action.payload.value;
            }
        },
        refreshFiltersValue(state) {
            state.filtersValue = Object.assign({}, defaultFiltersValue);
        },
        toggleIsRefreshedState(state, action) {
            state.isRefreshed = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadFiltersAsync.fulfilled, (state, action) => {
                state.filtersData = action.payload;
            });
    },
});

export const {modifyFilterValue, refreshFiltersValue, toggleIsRefreshedState} = filterSlice.actions;
export const selectFiltersData = (state) => state.cleaningFilter.filtersData;
export const selectFiltersValueDate = (state) => state.cleaningFilter.filtersValue.date;
export const selectFiltersValueZones = (state) => state.cleaningFilter.filtersValue.zones;
export const selectFiltersValue = (state) => state.cleaningFilter.filtersValue;
export default filterSlice.reducer;